/* global jQuery */
import jQuery from 'jquery';
import Svg4Everybody from 'svg4everybody';
import objectFitImages from 'object-fit-images';
import loadingAttributePolyfill
  from "loading-attribute-polyfill/dist/loading-attribute-polyfill";

// Relative Imports
import Accordion from './modules/accordion';
import Citation from './modules/citation';
import Filters from './modules/filters';
import HeaderSearch from './modules/header-search';
import MobileFilters from './modules/mobile-filters';
import MobileMenu from './modules/mobile-menu';
import QuotesSlider from './modules/quotes-slider';
import ToggleOpen from './modules/toggle-open';
import ToggleOpenMobileOnly from './modules/toggle-open--mobile-only';
import SocialSharing from './modules/social-sharing';
import Sorters from './modules/sorters';
import VideoBanner from './modules/video-banner';


(function ($) {
  const debug = true;

  /**
   * Anchor menu
   */
  new ToggleOpenMobileOnly('.js-anchor-heading', '.js-anchor-sub-list');

  /**
   * Citations
   */
  new Accordion();

  /**
   * Citations
   */
  new Citation();

  /**
   * Filters
   */
  new Filters('.js-filters');

  /**
   * Search in header
   */
  new HeaderSearch();

  /**
   * Mobile filters
   */
  new MobileFilters('.js-mobile-filters-button', '.js-mobile-filters');

  /**
   * Mobile menu
   */
  new MobileMenu('.js-hamburger', '.js-main-menu', '.js-menu-item-expand', '.js-sub-menu');

  /**
   * Quotes slider
   */
  new QuotesSlider();

  /**
   * Read more
   */
  new ToggleOpen('.js-read-more-button', '.js-read-more-content');

  /**
   * Secondary nav
   */
  new ToggleOpenMobileOnly('.js-group-heading', '.js-group-wrapper');

  /**
   * Social sharing
   */
  new SocialSharing('.js-social-share');

  /**
   * Sorters
   */
  new Sorters('.js-sorter');

  /**
   * Sorters
   */
  new VideoBanner(767);
  /**
   * SVG4Everybody
   */
  new Svg4Everybody();

  /**
   * Object fit polyfill
   */
  objectFitImages();

}(jQuery));

